import { isDefined } from '@evorait/pace-core';
import { on } from '@ngrx/store';
import { ContentId } from '../../../types/content-block';
import { FunctionalElement } from '../../../types/functional-element';
import { updateOptionSet } from '../../actions/functional-elements.actions';
import { FormState } from '../../state/form.state';
import { updateStateAfterContentChanges } from './form-reducer.utilities';

export function updateOptionSetFunctionalElementReducer(
    state: Readonly<FormState>,
    props: {
        id: ContentId;
        xmlId: string;
        newValue: boolean;
    },
): Readonly<FormState> {
    const oldFunctionalElement = state.participantCopies[state.selectedParticipantCopyId].functionalElements[props.id];

    if (!isDefined(oldFunctionalElement.optionSet)) {
        return state;
    }

    const expectedGroupOptionSet = oldFunctionalElement.optionSet.find((groupOptionSet) =>
        groupOptionSet.options.some((option) => option.id === props.xmlId && option.selected !== props.newValue),
    );

    if (!isDefined(expectedGroupOptionSet)) {
        return state;
    }

    const newOptionSet = oldFunctionalElement.optionSet.map((groupOptionSet) => {
        const containsExpectedOption = groupOptionSet.options.some((option) => option.id === props.xmlId);
        if (containsExpectedOption) {
            return {
                ...groupOptionSet,
                options: groupOptionSet.options.map((option) =>
                    option.id === props.xmlId ? { ...option, selected: props.newValue } : option,
                ),
            };
        }
        return groupOptionSet;
    });

    const newFunctionalElement: { [key: string]: FunctionalElement } = {
        [props.id]: {
            ...oldFunctionalElement,
            optionSet: newOptionSet,
        },
    };

    return updateStateAfterContentChanges(state, {
        ...state.participantCopies[state.selectedParticipantCopyId].functionalElements,
        ...newFunctionalElement,
    });
}

export const optionSetReducer = [
    on<FormState, Array<typeof updateOptionSet>>(updateOptionSet, updateOptionSetFunctionalElementReducer),
];
